import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { searchParamSet } from '../../../../actions/SearchSolutionActions';
import { propBool, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
const SearchCheckBox = ({ id, isCheck, label, rowClassName, setParam }) => (_jsxs("div", Object.assign({ className: rowClassName }, { children: [_jsx("input", { checked: isCheck, className: 'mdc-checkbox__native-control', id: id, onChange: setParam, type: 'checkbox' }), _jsx("label", Object.assign({ htmlFor: id }, { children: label }))] })));
SearchCheckBox.propTypes = {
    id: propStr().isRequired,
    isCheck: propBool().isRequired,
    label: propStr().isRequired,
    rowClassName: propStr(),
    setParam: propFunc().isRequired,
};
SearchCheckBox.defaultProps = {
    rowClassName: 'select-checkbox',
};
const mapStateToProps = ({ searchSolution }, { id }) => ({
    isCheck: (searchSolution.params || {})[id] || false,
});
const mapDispatchToProps = (dispatch) => ({
    setParam: (e) => {
        const { target } = e;
        dispatch(searchParamSet({
            [target.id]: target.checked,
        }));
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(SearchCheckBox);
